module.exports = __webpack_public_path__ + "img/二维码.e3a242db.jpg";